import { render, staticRenderFns } from "./GeneralSummary.vue?vue&type=template&id=17494106&scoped=true&"
import script from "./GeneralSummary.vue?vue&type=script&lang=ts&"
export * from "./GeneralSummary.vue?vue&type=script&lang=ts&"
import style0 from "./general-summary.scss?vue&type=style&index=0&id=17494106&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17494106",
  null
  
)

export default component.exports